import { ChangeDetectionStrategy, Component, HostBinding, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'mc-snack-bar-error',
  templateUrl: './snack-bar-error.component.html',
  styleUrls: ['./snack-bar-error.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackBarErrorComponent {
  @HostBinding('class') class = 'mc-snack-bar';

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public message: string,
    private snackBarRef: MatSnackBarRef<SnackBarErrorComponent>
  ) {
    this.snackBarRef.containerInstance.snackBarConfig.panelClass = ['mc-snack-bar', 'mc-snack-bar-panel', 'mc-warn'];
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
